import i18n from '../../i18n/en.json';

/**
 * @const {object}
 * @memberOf module:ApplicationsPermits
 */
export const apLaserRequestSafetyPlan = {
    bindings: {
        type: '@',
    },
    /* @ngInject */
    controller: function ($ngRedux, $state) {
        /**
         * @function $onInit
         */
        this.$onInit = () => {
            this.ackUL = i18n[this.type].safetyPlan.ul;

            this.unsubscribe = $ngRedux.connect(({ applicationsPermits }) => ({
                apLaserRequest: applicationsPermits.apLaserRequest,
            }), {})(this);

            this.identifier = $state.$current.parent.name;
            this.state = `${this.identifier}.safetyPlan`;

            const { title, first_name, last_name } = this.apLaserRequest;
            this.title = `${title} ${first_name} ${last_name} - Acknowledgement`;
        }

        this.$onDestroy = () => {
            this.unsubscribe();
        }
    },
    template: require('./ap-laser-request-safety-plan.html')
};
